Vue.component('ppcarto-bar-sections', {
  template: '\
    <div class="topbar__area topbar__area--sections"> \
      <ul class="topbar__btngrp"> \
        <ppcarto-bar-section-item v-for="section in sections" :section="section"></ppcarto-bar-section-item>\
      </ul> \
    </div>',
  props: ['sections'],
  data: function (){
    {}
  },

  computed: {
    selected () {
      return this.$store.getters.selectedSections
    }
  },

  mounted () {
    //console.dir(this.selected);
  }

});
